<div class="Table flex flex-col" *ngIf="config$ | async as conf">
  <aw-search-bar
    *ngIf="search"
    class="w-[400px] self-center my-2"
    #search
    [style]="'modern'"
    [searchValue]="query$ | async"
    [placeholder]="'COMMON.SEARCH' | translate"
    (searchChange)="query$.next($event); page$.next(1)"
  ></aw-search-bar>

  <ng-container *ngIf="query$ | async as query">
    <div class="Table__searchresults" *ngIf="query?.length && !IS_LOADING">
      Din sökning efter&nbsp;<strong>{{ query }}</strong
      >&nbsp;gav&nbsp;<span *ngIf="(result$ | async).next">fler än &nbsp;</span><strong>{{ (result$ | async).data.length }}</strong
      >&nbsp;resultat
    </div>
  </ng-container>

  <ngx-datatable
    #datatable
    class="material fullscreen Table__table"
    columnMode="force"
    [headerHeight]="40"
    [footerHeight]="40"
    [rowHeight]="40"
    [class.Table__table--viewonly]="READONLY"
    [externalSorting]="conf.externalSorting"
    [sorts]="sorts$ | async"
    [loadingIndicator]="IS_LOADING"
    [reorderable]="false"
    [messages]="messages"
    [rows]="(result$ | async)?.data"
    [columns]="conf.columns"
    [count]="(result$ | async)?.data.length"
    [limit]="conf.limit"
    [rowClass]="getRowClass"
    [selected]="selected"
    [selectionType]="selectionTypes.checkbox"
    (sort)="sort$.next({ prop: $event.column.prop, dir: $event.newValue })"
    (select)="rowSelect.emit($event.selected)"
    (activate)="onActivate($event)"
  >
    <ngx-datatable-column
      *ngIf="conf.options.selectable"
      [width]="30"
      [sortable]="false"
      [canAutoResize]="false"
      [draggable]="false"
      [resizeable]="false"
      [headerCheckboxable]="true"
      [checkboxable]="true"
    >
    </ngx-datatable-column>

    <ngx-datatable-column
      *ngFor="let column of conf.columns"
      [name]="column.name"
      [prop]="column.prop"
      [cellTemplate]="column.cellTemplateRef"
      [sortable]="column.disableSorting ? false : true"
      [flexGrow]="column.flexGrow ? column.flexGrow : null"
      [width]="column.width ? column.width : null"
      [minWidth]="column.minWidth ? column.minWidth : null"
      [maxWidth]="column.maxWidth ? column.maxWidth : null"
      [pipe]="column.pipe ? column.pipe : null"
      [frozenRight]="column.frozenRight ? column.frozenRight : false"
      [frozenLeft]="column.frozenLeft ? column.frozenLeft : false"
      [canAutoResize]="false"
      [draggable]="false"
      [resizeable]="false"
    >
    </ngx-datatable-column>

    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template let-rowCount="rowCount">
        <div class="Table__footer flex-1 flex items-center justify-between" *ngIf="result$ | async as result">
          <div class="text-black text-base">
            {{ 'PAGE.PAGE' | translate }} {{ result.page }}: {{ rowCount }} {{ 'PAGE.RESULTS' | translate }}
          </div>
          <div>
            <button mat-icon-button (click)="page$.next(1)" [disabled]="result.page === 1 || IS_LOADING">
              <mat-icon class="text-black">first_page</mat-icon>
            </button>
            <button mat-icon-button (click)="page$.next(result.page - 1)" [disabled]="result.page === 1 || IS_LOADING">
              <mat-icon class="text-black">keyboard_arrow_left</mat-icon>
            </button>
            <button mat-icon-button (click)="page$.next(result.page + 1)" [disabled]="!result.next || IS_LOADING">
              <mat-icon class="text-black">keyboard_arrow_right</mat-icon>
            </button>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>
</div>

<ng-template #colorCellTemplate let-column="column" let-row="row" let-value="value">
  <div
    class="Table__color-badge"
    [style.--color]="value"
    [matTooltipDisabled]="!getColumnConfigFromProp(column.prop, 'tooltip')?.enabled"
    [matTooltip]="
      getColumnConfigFromProp(column.prop, 'tooltip')?.value ?? getColumnConfigFromProp(column.prop, 'tooltip')?.valueProp
        ? row[getColumnConfigFromProp(column.prop, 'tooltip').valueProp]
        : null
    "
    [matTooltipPosition]="getColumnConfigFromProp(column.prop, 'tooltip')?.position || 'left'"
  ></div>
</ng-template>

<ng-template #attributeSimpleCellTemplate let-column="column" let-row="row" let-value="value">
  <span
    [matTooltipDisabled]="!getColumnConfigFromProp(column.prop, 'tooltip')?.enabled"
    [matTooltip]="getColumnConfigFromProp(column.prop, 'tooltip')?.value || row.attr(column.prop)"
    [matTooltipPosition]="getColumnConfigFromProp(column.prop, 'tooltip')?.position || 'left'"
    >{{ row.attr(column.prop) }}</span
  >
</ng-template>

<ng-template #attributeTextCellTemplate let-column="column" let-row="row" let-value="value">
  <span
    [matTooltipDisabled]="!getColumnConfigFromProp(column.prop, 'tooltip')?.enabled"
    [matTooltip]="getColumnConfigFromProp(column.prop, 'tooltip')?.value || row.attr(column.prop, 'text')"
    [matTooltipPosition]="getColumnConfigFromProp(column.prop, 'tooltip')?.position || 'left'"
    >{{ row.attr(column.prop, 'text') }}</span
  >
</ng-template>
